<template>
  <svg
    class="play-icon"
    xmlns="http://www.w3.org/2000/svg"
    xml:space="preserve"
    viewBox="0 0 100 100">
    <g transform="translate(-492 -1656)">
      <circle cx="542" cy="1706" r="47" opacity=".357" />
      <g class="btn" fill="#fff">
        <path d="M530.5 1719.9v-25.5l25.6 12.8-25.6 12.7z" />
        <path
          d="m548.4 1707.1-14.4-7.2v14.4l14.4-7.2m12.5 0c0 .8-.4 1.6-1.3 2.1l-29.2 14.6c-1.5.8-3.3-.3-3.3-2.1v-29.2c0-1.7 1.8-2.8 3.3-2.1l29.3 14.6c.8.5 1.2 1.3 1.2 2.1z" />
      </g>
      <g fill="none" transform="translate(495 1659)">
        <circle cx="47" cy="47" r="40.1" />
        <circle
          class="border"
          cx="47"
          cy="47"
          r="36.7"
          stroke="#fff"
          stroke-width="3" />
      </g>
    </g>
  </svg>
</template>
